<ng-container *ngFor="let officer of content.bannerContent; let i = index">
  <div class="information-container">
    <div class="details">
      <dd class="text-wrap" [innerHTML]="safeHTML(officer.icon)"></dd>
      <dd class="text-wrap">
        {{ officer.data.messageTranslation }}
      </dd>
    </div>
    <div class="time">
      <dt>{{ formatDate(officer.data.notification.notificationReceivedTime) }}</dt>
    </div>
    <br />
  </div>
</ng-container>
